import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PageHeader from "../components/PageHeader";

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <PageHeader 
        title="Refund Policy"
      />
      
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-8">
            <h1 className="text-2xl font-bold mb-2">EMU Mentoring Pty Ltd Refund Policy</h1>
            <p className="text-gray-600 mb-6">
              <strong>Last updated:</strong> 25/08/2025
            </p>
            <p className="text-gray-700">
              At EMU Mentoring Pty Ltd, we are committed to delivering a high-quality experience for both mentors and mentees. We understand that circumstances may arise where a refund is necessary. This Refund Policy outlines the conditions under which refunds may be granted and the procedures for requesting one. This Policy applies in addition to our Terms of Service and your rights under the Australian Consumer Law (ACL).
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Eligibility for Refunds</h2>
            <p className="text-gray-700 mb-4">
              Refunds may be granted under the following circumstances:
            </p>
            <ul className="list-disc pl-5 text-gray-700 mb-4 space-y-2">
              <li><strong>Session Not Delivered:</strong> The mentor fails to deliver a booked session without prior notice or rescheduling.</li>
              <li><strong>Unsatisfactory Service:</strong> The session does not meet the agreed expectations or quality standards, and concerns are raised within 24 hours of the session.</li>
              <li><strong>Technical Issues:</strong> The session could not proceed due to verified technical failures beyond the user's control (e.g., platform errors or connectivity issues).</li>
            </ul>
            <p className="text-gray-700">
              All refund requests are subject to review and approval by our support team. We reserve the right to request supporting evidence (e.g., screenshots, communication logs, or session records where available).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Non-Refundable Fees</h2>
            <p className="text-gray-700 mb-4">
              All approved refunds will be processed excluding the Stripe transaction fee, which is non-refundable. This fee is charged directly by our third-party payment processor and is not recoverable by EMU Mentoring Pty Ltd.
            </p>
            <p className="text-gray-700">
              <strong>Example:</strong> If a session cost $100 and the Stripe fee was $3, the maximum refundable amount is $97.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. How to Request a Refund</h2>
            <p className="text-gray-700 mb-4">
              To request a refund, email <a href="mailto:support@emumentoring.com" className="text-emu-blue hover:underline">support@emumentoring.com</a> within 7 days of the session date. Please include:
            </p>
            <ul className="list-disc pl-5 text-gray-700 mb-4 space-y-2">
              <li>Your full name and registered email address</li>
              <li>Booking ID or session reference</li>
              <li>Reason for the refund request</li>
              <li>Any relevant supporting evidence</li>
            </ul>
            <p className="text-gray-700">
              Our team will review your request within 3–5 business days and notify you of the outcome via email.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Refund Processing</h2>
            <p className="text-gray-700 mb-4">If your refund is approved:</p>
            <ul className="list-disc pl-5 text-gray-700 mb-4 space-y-2">
              <li>The refund (minus Stripe fees) will be issued to the original payment method.</li>
              <li>Processing times may vary depending on your financial institution, typically 7–10 business days.</li>
              <li>Refund decisions made by EMU Mentoring Pty Ltd are final.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Exceptions</h2>
            <p className="text-gray-700 mb-4">
              Refunds will not be provided in the following situations:
            </p>
            <ul className="list-disc pl-5 text-gray-700 mb-4 space-y-2">
              <li>The mentee did not attend the session and did not cancel in advance.</li>
              <li>The refund request was submitted more than 7 days after the session date.</li>
              <li>The session was delivered and completed without issue, and no service concerns were raised.</li>
              <li>The user violates our Terms of Service or attempts to abuse the refund system.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Contact</h2>
            <p className="text-gray-700 mb-4">
              If you have questions regarding this Refund Policy, please contact us at:
            </p>
            <p className="text-gray-700">
              Email: <a href="mailto:support@emumentoring.com" className="text-emu-blue hover:underline">support@emumentoring.com</a>
            </p>
          </section>

          <div className="border-t border-gray-200 pt-6">
            <p className="text-gray-600">
              Have questions? <Link to="/contact" className="text-emu-blue hover:underline">Contact us</Link> for more information.
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default RefundPolicy;